import { faUniversity } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { memo } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getFullAddress } from "utils/Utils";
import hospital_icon_blue from "assets/images/hospital-icon-blue.png";

const RenderRecentExperience = (props) => {
  const { institutionDetail } = props;

  if (institutionDetail === null) {
    return null;
  }

  const institutionName = getFullAddress({
    name: institutionDetail?.name ?? "",
    abbreviation: institutionDetail?.abbreviation ?? "",
    location: institutionDetail?.address?.location ?? "",
    city: institutionDetail?.address?.city ?? "",
    state: institutionDetail?.address?.state ?? "",
  });
  const profileIdLink = institutionDetail?.profileId
    ? institutionDetail?.profileId
    : institutionDetail?.guid;

  return (
    <>
    {institutionDetail ? (
    <div className="nexogic-profile-banner-links">
      <div className="item">
        <img src={hospital_icon_blue} alt="" className="icon" />
        <p className="card-text"><Link
            to={`/institution/${profileIdLink}`}
            className=""
          >{institutionName}</Link></p>
      </div>
      <div className="row">
        <div className="exp-blk-logo col-auto">
          
          {/** <FontAwesomeIcon icon={faUniversity} className="fa-fw" size="2x" />*/}
        </div>
        <div className="col">
          
            
          
        </div>
      </div>
    </div>
  ):(
    <div className="line-progress">
    <div className="row">
        <div className="col">          
            <p>No Institution Details</p>
        </div>
      </div>
      </div>
      )}
  </>
  );
};

const ContainerRecentExperience = () => {
  const recentExperienceList = useSelector(
    (state) => state.RecentExperienceReducer.recentExperienceList
  );
  const recentEducationList = useSelector(
    (state) => state.RecentExperienceReducer.recentEducationList
  );
  const allRecentExperience = [...recentExperienceList, ...recentEducationList];

  if (allRecentExperience.length === 0) {
    return null;
  }
  return allRecentExperience.map((node, index) => (
    <RenderRecentExperience
      institutionDetail={node?.institutionDetail ?? null}
      key={index.toString()}
    />
  ));
};

export default memo(ContainerRecentExperience);
